import React , { useState } from 'react';
import ky from 'ky';
import styled from 'styled-components';
import { Grid, Paper, TextField, Button, Typography } from '@material-ui/core';
import { Link } from 'react-router-dom';
import { useDispatch } from 'react-redux';

import { authLogin, setLatest, setSnackbar } from '../redux/workBackendSlice';
import { isLogined, initializeSlices } from '../redux/dataBackend';
import { updateUser } from '../redux/userDbSlice';
import useWorkBackend from '../hooks/useWorkBackend';
import useCurrentUserDb from '../hooks/useCurrentUserDb'
import useLanguageDb from '../hooks/useLanguageDb';
import { getAuthErrorMessage, clearTokensOfCookie } from '../general';
import { apiURL } from './DigimagiProvider';
import Redirector from './Redirector';
import SignInScene from './SignInScene';
import DigimagiAppBar from './DigimagiAppBar';
import ConfirmPasswordDialog from './ConfirmPasswordDialog';

const WrapperGrid = styled(Grid)`
  padding: 8px;
  height: inherit;
`
const UserSettingsPaper = styled(Paper)`
  height: max(100% - 64px, 100vh - 64px);
`
const LabelTypography = styled(Typography)`
  color: #9e9e9e;
`
const PlainLink = styled(Link)`
  text-decoration: none;
`

type UserSettingsProps = {
  redirected: boolean;
  setRedirected: (value: boolean) => void;
  appBarFrom: '/' | '/book';
}
const UserSettings: React.FC<UserSettingsProps> = ({ redirected, setRedirected, appBarFrom }) => {
  const dispatch = useDispatch();
  const authUser = useWorkBackend().authUser;
  const [userId, currentUser] = useCurrentUserDb();
  const languages = useLanguageDb();
  const [confirmPasswordState, setConfirmPasswordState] = useState<{ open: boolean; title: string; action: (() => void) | null }>({ open: false, title: '', action: null });
  
  const [userName, setUserName] = useState<string>(currentUser?.name || '');
  const [userMail, setUserMail] = useState<string>(currentUser?.mail || '');
  const [userPassword, setUserPassword] = useState<string>('');
  const [rePassword, setRePassword] = useState<string>('');
  const [language, setLanguage] = useState(currentUser ? languages[currentUser.language].name : '');

  //ユーザー名を変更
  const changeNameExe = () => {
    if (!userId || !currentUser || userName === '' || currentUser.name === userName) return;
    const exe = () => {
      const data = { id: userId, name: userName };
      if (!authUser || authUser === 'noAuth') return;
      ky.post(`${apiURL}update_account`, { json: { target: 'username', user_id: userId, username: userName } }).then(() => {
        dispatch(updateUser(data));
        dispatch(setSnackbar({ open: true, message: 'ユーザ名を変更しました。'}));
      }).catch(err => {
        console.log(err);
        alert('適切なユーザ名ではありません');
      });
    }
    setConfirmPasswordState({ open: true, title: '新しいユーザ名に変更するには、現在のパスワードを入力してください', action: exe });
  }
  //メールアドレスを変更
  const changeMail = () => {
    if (!userId || !currentUser || userMail === '' || currentUser.mail === userMail) return;
    const exe = () => {
      const data = { id: userId, mail: userMail };
      if (!authUser || authUser === 'noAuth') return;
      ky.post(`${apiURL}update_account`, { json: { target: 'email', user_id: userId, email: userMail } }).then(() => {
        dispatch(updateUser(data));
        dispatch(setSnackbar({ open: true, message: 'メールアドレスを変更しました。'}));
      }).catch(err => {
        console.log(err);
        alert('適切なメールアドレスではありません');
      });
    }
    setConfirmPasswordState({ open: true, title: '新しいメールアドレスに変更するには、現在のパスワードを入力してください', action: exe });
  }
  //パスワードを変更
  const changePassword = () => {
    if (!userId || !currentUser || userPassword === '' || rePassword === '' || userPassword !== rePassword) return;
    const exe = () => {
      if (!authUser || authUser === 'noAuth') return;
      ky.post(`${apiURL}update_account`, { json: { target: 'password', user_id: userId, password: userPassword } }).then(() => {
        dispatch(setSnackbar({ open: true, message: 'パスワードを変更しました。'}));
        setUserPassword('');
        setRePassword('');
      }).catch(err => {
        console.log(err);
        alert('適切なパスワードではありません');
      });
    }
    if (userPassword === rePassword) setConfirmPasswordState({ open: true, title: '新しいパスワードに変更するには、現在のパスワードを入力してください', action: exe });
    else alert('パスワードが一致していません');
  }
  const authSignOut = async () => {
    try {
      clearTokensOfCookie();
      dispatch(authLogin(false));
      dispatch(initializeSlices());
      dispatch(setLatest(false));
    } catch (err) {
      console.log(err);
    }
  }

  if (!redirected) return <Redirector doneRedirect={() => setRedirected(true)} />;
  else if (!isLogined()) return <SignInScene setRedirected={setRedirected} />;
  else return (
    <>
      <DigimagiAppBar setRedirected={setRedirected} parent='UserSettings' appBarFrom={appBarFrom} />
      <Grid container>
        <Grid item container>
          <Grid item md={12}>
            <UserSettingsPaper square>
              <WrapperGrid container justifyContent="center" alignItems="center">
                <Grid item xs={6}>
                  <TextField label="ユーザ名" value={userName} variant="outlined" fullWidth onChange={(ev) => setUserName(ev.target.value)}/>
                </Grid>
                <Grid item xs={5}>
                  <Button color='primary' size="large" onClick={() => changeNameExe()} disabled={userName.length === 0 || currentUser?.name === userName}>ユーザ名の変更を保存する</Button>
                </Grid>
                <Grid item xs={6}>
                  <TextField label="メールアドレス" value={userMail} variant="outlined" fullWidth onChange={(ev) => setUserMail(ev.target.value)}/>
                </Grid>
                <Grid item xs={5}>
                  <Button color='primary' size="large" onClick={() => changeMail()} disabled={userMail.length === 0 || currentUser?.mail === userMail}>メールアドレスの変更を保存する</Button>
                </Grid>
                <Grid item xs={6} style={{ marginTop: '40px' }}>
                  <TextField label="新しいパスワードに変更する" value={userPassword} variant="outlined" type="password" fullWidth onChange={(ev) => setUserPassword(ev.target.value)}/>
                </Grid>
                <Grid item xs={5}>
                </Grid>
                <Grid item xs={6}>
                  <TextField label="新しいパスワードに変更する（確認用）" value={rePassword} variant="outlined" type="password" fullWidth onChange={(ev) => setRePassword(ev.target.value)}/>
                </Grid>
                <Grid item xs={5}>
                  <Button color='primary' size="large" onClick={() => changePassword()} disabled={userPassword === '' || rePassword === ''}>パスワードの変更を保存する</Button>
                </Grid>
                {/* <Grid item xs={12} container justifyContent="center" alignItems="flex-end" spacing={4}>
                  <Grid item xs={3}>
                    <LabelTypography variant="caption">現在のプラン</LabelTypography>
                    <Typography variant="h6">フリープラン</Typography>
                  </Grid>
                  <Grid item xs={3} style={{ paddingBottom: '12px' }}>
                    <PlainLink to="/changePlan">
                      <Button color='primary' size="large">プランを変更する</Button>
                    </PlainLink>
                  </Grid>
                </Grid>
                <Grid item xs={12} container justifyContent="center" alignItems="flex-end" spacing={4}>
                  <Grid item xs={3}>
                    <LabelTypography variant="caption">現在の決済方法</LabelTypography>
                    <Typography variant="h6">未設定</Typography>
                  </Grid>
                  <Grid item xs={3} style={{ paddingBottom: '12px' }}>
                    <PlainLink to="changePayment">
                      <Button color='primary'size="large">決済方法を変更する</Button>
                    </PlainLink>
                  </Grid>
                </Grid>
                <Grid item xs={12} container justifyContent="center" alignItems="flex-end" spacing={4}>
                  <Grid item xs={3}>
                    <LabelTypography variant="caption">現在の言語</LabelTypography>
                    <Typography variant="h6">{ language }</Typography>
                  </Grid>
                  <Grid item xs={3} style={{ paddingBottom: '12px' }}>
                    <PlainLink to="changeUserLanguage">
                      <Button color='primary' size="large">言語を変更する</Button>
                    </PlainLink>
                  </Grid>
                </Grid> */}
                <Grid item xs={12}>
                  <Grid container justifyContent="center">
                    <Grid item>
                      <Button color="secondary" onClick={authSignOut}>ログアウトする</Button>
                    </Grid>
                  </Grid>
                </Grid>
              </WrapperGrid>
            </UserSettingsPaper>
          </Grid>
        </Grid>
      </Grid>
      { confirmPasswordState.action &&
        <ConfirmPasswordDialog open={confirmPasswordState.open} onClose={() => setConfirmPasswordState({ open: false, title: '', action: null })}
          title={confirmPasswordState.title} actionWithConfirmation={confirmPasswordState.action}
        />
      }
    </>
  );
}

export default UserSettings;
